import { render, staticRenderFns } from "./WaitingApprovePage.vue?vue&type=template&id=28bfbaef&scoped=true&"
import script from "./WaitingApprovePage.vue?vue&type=script&lang=ts&"
export * from "./WaitingApprovePage.vue?vue&type=script&lang=ts&"
import style0 from "./WaitingApprovePage.vue?vue&type=style&index=0&id=28bfbaef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bfbaef",
  null
  
)

export default component.exports